Core.Cart = {
    init: function () {
        Core.Cart.Cache = {
            $cartTable: $('#cart-table'),
            $cartEmpty: $('#cart-empty'),
            $cartTotals: $('#cart-totals'),
            $updateItem: $('.cart-update'),
            $postcode: $('#Postcode'),
            $postcodeError: $('#postcodeError'),
            $removeItem: $('.remove-cart-item'),
            $favouritesBtn: $('.favourites-btn'),
            $subTotal: $('#subTotal'),
            $gst: $('#gst'),
            $total: $('#total'),
            $onBehalfTitle: $('#OnBehalfTitle'),
            $shipping: $('#shipping'),
            $submitCart: $('#btn-request-cart'),
            $organization: $('#Organization'),
            $freightOption: $('#freightOption'),
            $shippingCompany: $('#shippingCompany'),
            $accountDetails: $('#accountDetails'),
            $hideFreight: $('#HideFreight'),
            $orderOrganization: $('#OrderOrganization'),
            $therapistID: $('#TherapistID'),
            $requestQuote: $('#request-quote'),
            $quoteButtons: $('.btn-quote'),
            $quoteForm: $('#quote-form'),
            $quoteWindow: $('#quote-notification'),
            $quoteFormButton: $('#btn-request-quote'),
            $fundingType: $('#FundingType'),
            $cartFormButton: $('#btn-request-cart'),
            $dvCheckoutNoApprovalRequired: $('#dvCheckoutNoApprovalRequired'),
            $checkoutNoApprovalRequired: $('#checkoutNoApprovalRequired'),
            $dvCheckoutMessageRequired: $('#dvCheckoutMessageRequired'),
            $checkoutMessageRequired: $('#checkoutMessageRequired'),
            $dvCapex: $('#dvCapex'),
            $checkoutMinThreshold: $('#CheckoutMinThreshold'),
            $checkoutMaxThreshold: $('#CheckoutMaxThreshold'),
            $capexThreshold: $('#CapexThreshold'),
            $punchoutForm: $('#frmPunchoutForm'),
            $punchoutForm1: $('#PunchoutReturnForm'),
            $xmlString: $('[name=cXML-urlencoded]'),

            $validator: $('.frm-quote').validate({
                focusInvalid: false,
                invalidHandler: function (form, validator) {

                    if (!validator.numberOfInvalids())
                        return;

                    $('html, body').animate({
                        scrollTop: $(validator.errorList[0].element.parentElement).offset().top - 30
                    }, 300);

                },
                rules: {
                    password: {
                        ContainsAtLeastOneDigit: true,
                        ContainsAtLeastOneCapitalLetter: true
                    }
                }
            })
        };

        function onSpin(context) {
            if ($(context).length > 0) {
                $('.cart-update', context).addClass('show');
                Core.Cart.disableRequestButton();
                Core.Cart.disableCartButton();
            }
        }

        function onPunchoutSubmit(xml) {
            Core.Cart.Cache.$xmlString.val(xml);
            Core.Cart.Cache.$punchoutForm.trigger('submit');
        }

        $('.product-qty').kendoNumericTextBox({
            format: "#",
            step: 1,
            change: function() {
                if (this.value() === null) {
                    this.value(1);
                }
            },
            spin: onSpin
        }).on('focus', function(e){
            var $qtyColumn = $(e.target).closest('.col-qty');
            onSpin($qtyColumn.siblings('.col-update')[0]);
        });

        //update cart item
        this.update();
        this.updateShipping();

        //remove cart item
        this.remove();

        //add|remove favourites
        this.addRemoveFavourties();

        //request quote
        this.requestQuote();

        this.initForm();

        var stockIntegration = new Core.StockIntegration('co_agedcare');
        stockIntegration.init();
    },
    initForm: function () {        
        var $form = $('#frmSearchContact');
        if ($form.length === 0) return;
        
        // Add timeout to wait for kendo
        setTimeout(function() {    
            $form.find('select').each(function(i, elem) {
                var $dropdown = $(elem);
                $dropdown.data("kendoDropDownList") && $dropdown.data("kendoDropDownList").value($dropdown.val() || ''); // give initial value                
            });   
        }, 300);

        $form.find('#btn-request-cart').on('click', function (e) {
            e.preventDefault();
            var isValid = true;
            
            $form.find('select[data-rule-required="true"]').each(function(i, elem) {                
                if (!SelectValidator(elem).isValid()) {
                    isValid = false;
                }
            });
            $form.find('input:visible[data-rule-required="true"]').each(function(i, elem) {                
                $(elem).valid();
            });

            // if (isValid && $form.valid()) $form.trigger('submit');
        });
    },
    disableRequestButton: function () {
        Core.Cart.Cache.$quoteFormButton.addClass('disabled').prop('disabled', true);
    },
    enableRequestButton: function () {
        Core.Cart.Cache.$quoteFormButton.removeClass('disabled').prop('disabled', false);
    },
    disableCartButton: function () {
        Core.Cart.Cache.$cartFormButton.addClass('disabled').prop('disabled', true);
    },
    enableCartButton: function () {
        Core.Cart.Cache.$cartFormButton.removeClass('disabled').prop('disabled', false);
    },
    checkCartButtonVisibility: function(output) {
        // HideFrieght === true /-> hasInvalidShippingCost = false <-
        // HideFrieght === false /-> output.ShippingCost > 0
        //                   -> but with genuine output.ShippingCost == 0
        //                   noShippingCost = true -> genuine 0
        //                   noShippingCost = false -> no genuine 0
        //
        //  HideFrieght -> site level
        //  noShippingCost -> item level

        var hasInvalidShippingCost = output
                                    && output.IsInvalidShipping
                                    && ! output.HideFrieght;

        if ($('.cart-update.show').length > 0 || hasInvalidShippingCost) {
            Core.Cart.disableRequestButton();
            Core.Cart.disableCartButton();
            $("#shippingError").html(output.Message);
            $("#shippingError").show();
        } else {
            Core.Cart.enableRequestButton();
            Core.Cart.enableCartButton();
            $("#shippingError").hide();
        }
    },
    update: function () {
        Core.Cart.Cache.$updateItem.on('click', function () {            
            var $updateBtn = $(this),
                _$item = $(this).parents('tr'),
                _qty = parseInt(_$item.find('.product-qty').eq(1).val()) !== "NaN" && parseInt(_$item.find('.product-qty').eq(1).val()) ? parseInt(_$item.find('.product-qty').eq(1).val()) : 1,
                _unitPrice = parseFloat(_$item.find('.unit-price').data("price"));

            var postcode = Core.Cart.Cache.$postcode.val() || "";
            var org = Core.Cart.Cache.$organization.val() || "";
            var freight = Core.Cart.Cache.$hideFreight.val() || "";
            var orderOrganization = Core.Cart.Cache.$orderOrganization.val() || "";
            var therapistID = Core.Cart.Cache.$therapistID.val() || "";
            var agedCare = ($(this).hasClass("aged-care"));
            var $url = ($(this).hasClass("aged-care"))
                            ? '/cart/updatecart' //'https://run.mocky.io/v3/543471ab-7551-4d2c-a5a3-d1bdf6eceafa'
                            : '/cart/updatequote';

            _$item.find('.product-qty').eq(1).val(_qty);

            Core.ShowPageLoading();

            // Testing purpose
            //
            // {
            //     "WasSuccess": true,
            //     "Result": "",
            //     "Name": null,
            //     "Url": null,
            //     "ImageUrl": null,
            //     "Code": null,
            //     "Quantity": 0,
            //     "PriceType": null,
            //     "Price": null,
            //     "Currency": "$",
            //     "SubTotal": "$6,900.00",
            //     "TaxTotal": "$22.40",
            //     "Total": "$7,146.40",
            //     "ShippingCost": "$224.00",
            //     "SubmitText": "Request Approval",
            //     "HideFreight": false,
            //     "Message": "",
            //     "IsInvalidShipping": false,
            //     "OrderStatus": 1,
            //     "UnitPrice": 2.2,
            //     "UnitPriceLabel": "$2.2"
            // }
            //
            // $url = 'https://run.mocky.io/v3/6b1681b8-c153-4fd4-8d1f-7393b81cc6df';
            // $url = 'https://run.mocky.io/v3/ea477288-b8c7-466b-9a19-5ffed2df2cd1'; // empty string additional info

            var org = Core.Cart.Cache.$organization.val() || "";
            var freightOption = Core.Cart.Cache.$freightOption.val() || "";
            var shippingCompany = Core.Cart.Cache.$shippingCompany.val() || "";
            var accountDetails = Core.Cart.Cache.$accountDetails.val() || "";

            var parameters = {
                code: _$item.data('id'),
                qty: _qty,
                postcode: postcode,
                organization: org,
                hideFreight: freight,
                orderOrganization: orderOrganization,
                therapistID: therapistID
            };

            if (org) parameters.organization = org;            
            if (freightOption) parameters.freightOption = freightOption;            
            if (shippingCompany) parameters.shippingCompany = shippingCompany;            
            if (accountDetails) parameters.accountDetails = accountDetails;

            $.ajax({
                url: $url,
                data: parameters,
                type: 'get',
                dataType: 'json',
                success: function (output) {
                    Core.HidePageLoading();
                    Core.Engine.getCartSummary();

                    var currency = output.Currency || '$';


                    if (_unitPrice > 0) {
                        (output.UnitPrice)
                            && (_unitPrice = output.UnitPrice);

                        // equivalent of UnitPriceLabel
                        (output.Price)
                            && _$item.find('[data-price]').text(output.Price);

                        _$item.find('.sub-total').text(currency + parseFloat(_qty * _unitPrice).toFixed(2));
                    } else {
                        _$item.find('.sub-total').text(Core.Config.POA.Text);
                    }

                    Core.Cart.UpdateTotals(output);
                    Core.Cart.UpdateMessages(output, agedCare);
                    Core.Cart.UpdateAdditionalInfo(_$item, output);

                    if ($updateBtn) {
                        $updateBtn.removeClass('show');
                    }

                    Core.Cart.checkCartButtonVisibility(output);
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    //todo: do something
                }
            });

            // check local stock
            /*
            if (!!$('#cart').data('check-local-stock-api')) {
                var stockIntegration = new Core.StockIntegration('co_agedcare');
                stockIntegration.updateStock(false, $updateBtn.closest('.product-row'));
            }
            */
        });
    },
    updateShipping: function () {
        function updateShipping() {
            Core.ShowPageLoading();
            Core.Cart.Cache.$submitCart.attr('disabled', false);

            var postcode = Core.Cart.Cache.$postcode.val() || "";
            var org = Core.Cart.Cache.$organization.val() || "";
            var freight = Core.Cart.Cache.$hideFreight.val() || "";
            var freightOption = Core.Cart.Cache.$freightOption.val() || "";
            var shippingCompany = Core.Cart.Cache.$shippingCompany.val() || "";
            var accountDetails = Core.Cart.Cache.$accountDetails.val() || "";
            var orderOrganization = Core.Cart.Cache.$orderOrganization.val() || "";
            var therapistID = Core.Cart.Cache.$therapistID.val() || "";
            var agedCare = ($(this).hasClass("aged-care"));

            var parameters = {
                postcode: postcode,
                organization: org,
                hideFreight: freight,
                orderOrganization: orderOrganization,
                therapistID: therapistID,
            };

            if (freightOption) parameters.freightOption = freightOption;            
            if (shippingCompany) parameters.shippingCompany = shippingCompany;            
            if (accountDetails) parameters.accountDetails = accountDetails;

            $.ajax({
                url: '/cart/updateshipping',
                // url: 'https://run.mocky.io/v3/df015c09-d1e9-449c-936e-f9b03bcd611d',
                data: parameters,
                type: 'get',
                dataType: 'json',
                success: function (output) {
                    Core.HidePageLoading();
                    Core.Engine.getCartSummary();

                    Core.Cart.UpdateTotals(output);
                    Core.Cart.UpdateMessages(output, agedCare);

                    Core.Cart.checkCartButtonVisibility(output);
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    console.error(thrownError);
                    Core.HidePageLoading();
                }
            });
        };

        function updateShippingLabel() {
            var orgVal = Core.Cart.Cache.$organization.val();
            var orgId = Core.Cart.Cache.$organization.attr('id');
            var orgLabel = $(`label[for="${orgId}"]`)?.data('label') || 'select facility';
            var freightVal = Core.Cart.Cache.$freightOption.val();
            var freightId = Core.Cart.Cache.$freightOption.attr('id');
            var freightLabel = $(`label[for="${freightId}"]`)?.data('label') || 'select freight term';

            Core.Cart.Cache.$submitCart.attr('disabled', true);
            if (!freightVal) {
                Core.Cart.Cache.$shipping.text(`Please ${freightLabel}`);
            } else if (!orgVal) {
                Core.Cart.Cache.$shipping.text(`Please ${orgLabel}`);
            }
        }

        Core.Cart.Cache.$postcode.on('change', updateShipping);
        Core.Cart.Cache.$organization.on('change', function() {
            // check if freight option exist
            if (Core.Cart.Cache.$freightOption.length > 0) {
                if (Core.Cart.Cache.$freightOption.val() && Core.Cart.Cache.$organization.val()) {
                    updateShipping();
                } else {
                    updateShippingLabel();
                }
            } else {
                updateShipping();
            }
        });

        Core.Cart.Cache.$freightOption.on('change', function() {
            var freightOption = $(this).val() || "";
            if (freightOption === 'OnAccount') {
                // show input
                $('#dvOnAccountFields').removeClass('hidden');
            } else {
                // hide input
                $('#dvOnAccountFields').addClass('hidden');
            }

            // check if facility dropdown exist
            if (Core.Cart.Cache.$organization.length > 0) {
                if (Core.Cart.Cache.$organization.val() && Core.Cart.Cache.$freightOption.val()) {
                    updateShipping();
                } else {
                    updateShippingLabel();
                }
            } else {
                updateShipping();
            }
        });

        // seems like kendo clash with jquery validation that makes the error message shows twice
        // so, do manual check if there is already error message (might need to ceck later for not hacky solution)
        // timeout needed to wait for kendo to finish its validation
        Core.Cart.Cache.$freightOption.on('blur', function() {
            var $parent = $(this).closest('.k-dropdownlist');
            setTimeout(function() {
                $parent.find('label.error').remove();
            }, 0);
        });
    },
    punchoutSubmit: function (xml, id) {
        if (id === 1) {
            Core.Cart.Cache.$xmlString.val(xml);
            $(document.body).append(Core.Cart.Cache.$punchoutForm);
            Core.Cart.Cache.$punchoutForm.trigger('submit');
        }
        else {
            Core.Cart.Cache.$punchoutForm1.html(xml);
            $(document.body).append(Core.Cart.Cache.$punchoutForm1);
            Core.Cart.Cache.$punchoutForm1.trigger('submit');
        }
    },
    remove: function () {
        Core.Cart.Cache.$removeItem.on('click', function () {
            var _$item = $(this).parents('tr'),
                _$siblings = _$item.siblings();

            Core.ShowPageLoading();

            var postcode = Core.Cart.Cache.$postcode.val() || "";
            var org = Core.Cart.Cache.$organization.val() || "";
            var freight = Core.Cart.Cache.$hideFreight.val() || "";
            var orderOrganization = Core.Cart.Cache.$orderOrganization.val() || "";
            var therapistID = Core.Cart.Cache.$therapistID.val() || "";
            var freightOption = Core.Cart.Cache.$freightOption.val() || "";
            var agedCare = ($(this).hasClass("aged-care"));
            var $url = ($(this).hasClass("aged-care"))
                            ? '/cart/removefromcart'
                            : '/cart/removefromquote';

            var parameters = {
                code: _$item.data('id'),
                postcode: postcode,
                organization: org,
                hideFreight: freight,
                orderOrganization: orderOrganization,
                therapistID: therapistID
            };

            if (freightOption) parameters.freightOption = freightOption;

            $.ajax({
                url: $url,
                data: parameters,
                type: 'get',
                dataType: 'json',
                success: function (output) {
                    Core.HidePageLoading();
                    Core.Engine.getCartSummary();

                    if (_$siblings.length !== 0) {
                        Core.Cart.UpdateTotals(output);
                        Core.Cart.UpdateMessages(output, agedCare);
                        _$item.remove();
                    }
                    else {
                        Core.Cart.Cache.$cartTable.add(Core.Cart.Cache.$cartTotals).add(Core.Cart.Cache.$quoteButtons).add(Core.Cart.Cache.$quoteForm).remove();
                        Core.Cart.Cache.$cartEmpty.show();
                    }

                    Core.Cart.checkCartButtonVisibility(output);
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    //todo: do something
                }
            });
        });
    },
    UpdateTotals: function (output) {
        Core.Cart.Cache.$subTotal.text(output.SubTotal);
        Core.Cart.Cache.$gst.text(output.TaxTotal);
        Core.Cart.Cache.$total.text(output.Total);

        if (output.IsInvalidShipping && Core.Cart.Cache.$postcode.length) {
            Core.Cart.Cache.$shipping.text('Enter Postcode');
            Core.Cart.Cache.$postcodeError.hide();
        } else if (output.IsInvalidShipping && Core.Cart.Cache.$organization.val() && Core.Cart.Cache.$organization.val().length < 1) {
            Core.Cart.Cache.$shipping.text(Core.Cart.Cache.$onBehalfTitle.val());
        }
        else {
            Core.Cart.Cache.$shipping.text(output.ShippingCost);
            Core.Cart.Cache.$postcodeError.hide();
        }

        Core.Cart.Cache.$submitCart.val(output.SubmitText);
    },
    UpdateMessages: function (output, agedCare) {
        if (agedCare) {
            if (output.OrderStatus === 2) {
                Core.Cart.Cache.$dvCheckoutNoApprovalRequired.show();
                Core.Cart.Cache.$dvCheckoutMessageRequired.hide();
            }
            else if (output.OrderStatus === 1) {
                Core.Cart.Cache.$dvCheckoutMessageRequired.show();
                Core.Cart.Cache.$dvCheckoutNoApprovalRequired.hide();
            } else {
                Core.Cart.Cache.$dvCheckoutMessageRequired.hide();
                Core.Cart.Cache.$dvCheckoutNoApprovalRequired.hide();
            }

            if (parseInt(output.Total.replace("$", "").replace(",", "")) > parseInt(Core.Cart.Cache.$capexThreshold.val())) {
                Core.Cart.Cache.$dvCapex.show();
            } else {
                Core.Cart.Cache.$dvCapex.hide();
            }
        }
    },
    UpdateAdditionalInfo: function ($row, item) {        
        if ($row.find('.additional-info').length > 0) {
            if (item.AdditionalInfo || item.AdditionalInfo === "") {
                $row.find('.additional-info').text(item.AdditionalInfo);
            }
        }

        if ($row.find('.col-gst').length > 0 && item.Gst) {
            $row.find('.col-gst > span').text(item.Gst);
        }

        var $local = $row.find(`.stock-local`);
        
        if ($local.length > 0) {
            $local.find('.stock-status').css('background-color', item.StockColor);
            $local.find('.stock-message').html(`${item.StockMessage}`);
            $local.addClass(CLS_CHECKED);
            $row.find(`.stock-national`)?.addClass(CLS_HIDE);
        }
    },
    addRemoveFavourties: function () {
        Core.Cart.Cache.$favouritesBtn.on('click', function () {
            var _$this = $(this),
                _$item = _$this.parents('tr'),
                _isFavourite = _$this.hasClass('icon-cart-fav');

            var _apiUrl = '';

            if (_isFavourite) {
                _apiUrl = '/cart/removefromfavourites';
            }
            else {
                _apiUrl = '/cart/addtofavourites';
            }

            $.ajax({
                url: _apiUrl,
                data: { code: _$item.data('id') },
                type: 'get',
                dataType: 'json',
                success: function (output) {
                    if (_isFavourite) {
                        _$this.removeClass('icon-cart-fav').addClass('icon-cart-fav-add').attr('title', 'Add to favourites');
                    }
                    else {
                        _$this.removeClass('icon-cart-fav-add').addClass('icon-cart-fav').attr('title', 'Remove from favourites');
                    }
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    //todo: do something
                }
            });
        });
    },
    requestQuote: function (e) {
        Core.Cart.Cache.$quoteFormButton.on('click', function () {
            Core.Cart.Cache.$quoteForm.show();
            Core.Cache.$body.add(Core.Cache.$html).animate({
                scrollTop: Core.Cart.Cache.$quoteForm.offset().top
            }, 500);
        });

        // Handle Funding type dropdown on change
        Core.Cart.Cache.$fundingType.on('change', function() {
          var $this = $(this);
          var fundingType = $this.val();
          var $ndisWrap =  $('#ndis-inputs-wrap');

          // if ndis selected, it will show NDIS-related fields
          if (fundingType.toLowerCase() === 'ndis'){
            $ndisWrap.removeClass('hidden');
            Core.Cart.Cache.$quoteForm.find('#ndis-inputs-wrap .radio-group:first input[type="radio"]').rules('add', {
              required: true,
              messages: {
                required: 'Please select one of the options above'
              },
              errorPlacement: function(error, element) {
                // need to move the error message for radio groups
                var $error = $(error).next('.error');
                if($error && $error.length > 0) {
                  var $parent = $error.closest('.frm-fld');
                  $error.css('marginBottom','8px')
                  $parent.append($error);
                }
              },
            })
          } else {
            $ndisWrap.addClass('hidden');
            Core.Cart.Cache.$quoteForm.find('input[type="radio"]').rules('remove', 'required')
          }
          
          // show funding type message
          var $fundingTypeMessage = $(`.fundingTypeMessage[data-id="${fundingType}"]`);
          $(`.fundingTypeMessage`).addClass('hidden');
          if ($fundingTypeMessage.length > 0) {
            $fundingTypeMessage.removeClass('hidden');
          }
        });

        Core.Cart.Cache.$quoteForm.on('submit', function (e) {
            e.preventDefault();

            // reset recaptcha on submit error
            // recaptcha is initialized from html page (https://www.aidacare.com.au/cart/)
            var resetRecaptcha = function() {
              if (grecaptcha && recaptcha1) {
                grecaptcha.reset(recaptcha1);
              }
            };

            var $form = $(this);
            var _$validationMessage = $form.find('.frm-validation-msg');
            _$validationMessage.html("");

            if ($form.valid()) {
                Core.ShowPageLoading();
                $.ajax({
                    url: $form.attr('action'),
                    data: $form.serialize(),
                    type: 'POST',
                    dataType: 'json',
                    success: function (output) {
                        Core.HidePageLoading();

                        _$validationMessage.hide();
                        if (output.Success) {
                            $form.hide();
                            var _width = Core.Config.CartNotification.Width,
                                _height = Core.Config.CartNotification.Height;

                            if (Core.IsMobile()) {
                                _width = Core.Cache.$window.width();
                            }

                            var _$confirmationWindow = Core.Cart.Cache.$quoteWindow.kendoWindow({
                                width: _width,
                                height: _height,
                                visible: false,
                                iframe: false,
                                modal: true,
                                resizable: false,
                                pinned: true,
                                draggable: false,
                                appendTo: '#content'
                            });

                            var _$regLink = _$confirmationWindow.find("a.register");
                            if (_$regLink.length > 0) {
                                var _$href = _$regLink.attr("href");
                                _$regLink.attr("href", _$href + "?quoteid=" + output.QuoteId);
                            }

                            _$confirmationWindow.data("kendoWindow").center().open();

                            $(".k-overlay").on('click', function() {
                                window.location.href = window.location.href;
                            });

                            $(".k-window-action > span.k-i-close, .cart-notification-buttons > a.k-i-close").on('click', function (e) {
                                window.location.href = window.location.href;
                            });

                        } else {
                            _$validationMessage.html('<div class="error-msg">' + output.ErrorMessage + '</div>').show();
                            Core.Cache.$body.add(Core.Cache.$html).animate({
                                scrollTop: _$validationMessage.offset().top - 40
                            }, 500);

                            resetRecaptcha();
                        }
                    },
                    error: function(xhr, ajaxOptions, thrownError) {
                        //todo: do something
                        resetRecaptcha();
                    }
                });
            } else {
                Core.Cart.Cache.$validator.focusInvalid();
            }
        });
    }
};

$(function() {
    $('.favourites-btn').on('click', function () {
        var _$this = $(this),
            _$item = _$this.parents('tr'),
            _isFavourite = _$this.hasClass('icon-cart-fav');

        var _apiUrl = '';

        if (_isFavourite) {
            _apiUrl = '/cart/removefromfavourites';
        }
        else {
            _apiUrl = '/cart/addtofavourites';
        }

        $.ajax({
            url: _apiUrl,
            data: { code: _$item.data('id') },
            type: 'get',
            dataType: 'json',
            success: function (output) {
                if (_isFavourite) {
                    _$this.removeClass('icon-cart-fav').addClass('icon-cart-fav-add').attr('title', 'Add to favourites');
                }
                else {
                    _$this.removeClass('icon-cart-fav-add').addClass('icon-cart-fav').attr('title', 'Remove from favourites');
                }
            },
            error: function (xhr, ajaxOptions, thrownError) {
                //todo: do something
            }
        });
    });
});
